import { Controller } from "@hotwired/stimulus"
import Select2 from 'select2'
import 'jquery-validation'
import 'select2/dist/css/select2.css'

if (!window.select2) {
  window.select2 = Select2()
}

export default class extends Controller {
  static targets = ['studentsInput', 'classroomsInput', 'addBtnStudents', 'addBtnClassrooms']

  connect() {
    // Init au connect (nécessaire car le contrôleur de validation lit
    // `select2("data")`), une seule fois. `width: '100%'` géré par select2.
    $('.js-select2-multiple').each(function () {
      if (!$(this).hasClass('select2-hidden-accessible')) {
        $(this).select2({ width: '100%' })
      }
    })
  }

  showStudentsInput(event) {
    event.preventDefault() // sinon le lien href="#" fait recharger la page (Turbo)
    if (this.hasStudentsInputTarget) {
      this.#removeValidationError(this.studentsInputTarget)
      this.#showInput(this.studentsInputTarget)
    }
  }

  showClassroomsInput(event) {
    event.preventDefault() // sinon le lien href="#" fait recharger la page (Turbo)
    if (this.hasClassroomsInputTarget) {
      this.#removeValidationError(this.classroomsInputTarget)
      this.#showInput(this.classroomsInputTarget)
    }
  }

  triggerDelete(event) {
    event.preventDefault()
    document.getElementById("delete-obs-btn").click()
  }

  #removeValidationError(target) {
    let errorElement = target.parentElement.querySelector("div.error")

    if (errorElement) {
      errorElement.remove()
    }
  }

  #showInput(target) {
    this.addBtnStudentsTarget.classList.add("hidden")
    this.addBtnClassroomsTarget.classList.add("hidden")

    this.addBtnStudentsTarget.nextElementSibling.classList.remove("mb-32px")
    this.addBtnClassroomsTarget.nextElementSibling.classList.remove("mb-32px")
    target.classList.remove("hidden")
    target.required = true

    const select = target.querySelector(".js-select2-multiple")
    if (!select) return

    // select2 est déjà initialisé au connect (largeur gérée par `width: '100%'`).
    // Auto-ouverture après la fin du clic (la navigation href="#" est bloquée).
    setTimeout(() => $(select).select2("open"), 0)
  }
}
